import React from 'react';
import { Button, Col, Icon, Modal, Row, Switch, Tag } from 'antd';

import { _getSupplierInformation } from '../actions';

class VerifyModal extends React.Component {
    render() {

        const { loading } = this.props;

        if(!this.state.supplier) {
            return(
                <div>{console.log("no suppliers")}</div>
            )
        }
        if (this.state.supplier) {
            // console.log(this.state.supplier)
            const { accounting, details } = this.state.supplier || '';
            const { accountName, bankName, accountNumber, bankCode, swiftCode } = accounting || '';
            const { companyName, address, postalCode, gstRegistered, unit } = details || '';
            const { accountingDocument, companyProfileDocument } = this.state || '';

            return(
                <Modal
                visible={this.props.modalVisible}
                onOk={this.handleOk}
                loading={loading}
                onCancel={this.handleCancel}
                className="modal"
                footer={[
                    <Button 
                        key="cancel" 
                        onClick={this.handleCancel}>
                            
                        Return

                    </Button>,

                    <Button 
                        key="save" 
                        type="primary" 
                        loading={loading} 
                        onClick={this.handleOk}>
                      Save
                    </Button>,

                  ]}>


                    <Row className="doc-verification-heading">
                        
                        <Col span={12}>
                            <Row type="flex" justify="space-between" style={{fontSize: '14px'}} >
                                <Col span={16}>
                                    <Row type="flex" gutter={8}>
                                        <Col>
                                            Accounting Info
                                        </Col>

                                        <Col>
                                            {(accountingDocument)? 
                                                <a 
                                                target={`accounting_doc_${accountingDocument}`} 
                                                href={accountingDocument} >
                                                    <Tag color="green" > Docs </Tag>
                                                </a>
                                            :
                                                <div ><Tag  color="#e6e6e6" > Docs </Tag></div>
                                            }
                                        </Col>
                                    </Row>
                                
                                </Col>

                                <Col  className="modal-switches" span={5}>
                                    <Switch 
                                        checked={this.state.isAccountingInfoVerified} 
                                        checkedChildren={<Icon type="check" />} 
                                        unCheckedChildren={<Icon type="cross" />}  
                                        onChange={(e) => this.handleAccountingVerified(e)}/>
                                </Col>
                               
                                
                            </Row>
                        </Col>
    
                        <Col span={12}>

                            <Row type="flex" justify="space-between" style={{fontSize: '14px'}} >

                                <Col span={16}>

                                    <Row type="flex" gutter={8}>
                                        <Col>
                                            Company Info
                                        </Col>

                                        <Col>
                                            {(companyProfileDocument)? 
                                                <a 
                                                target={`company_doc_${companyProfileDocument}`} 
                                                href={companyProfileDocument} >
                                                    <Tag color="green" > Docs </Tag>
                                                </a>
                                            :
                                                <div ><Tag  color="#e6e6e6" > Docs </Tag></div>
                                            }
                                        </Col>
                                    </Row>

                                </Col>

                                <Col className="modal-switches" span={5}>

                                    <Switch 
                                        checked={this.state.isCompanyInfoVerified} 
                                        checkedChildren={<Icon type="check" />} 
                                        unCheckedChildren={<Icon type="cross" />}  
                                        onChange={(e) => this.handleCompanyVerified(e)}/>

                                </Col>
                               
                            </Row>
    
                        </Col>
    
                    </Row>

                    <Row className="doc-verification-info">

                    <Col span={12}>

                        <Row>
                            <Row className="field-headers">
                                Account Name 
                            </Row>

                            <Row className="field-content">
                                {accountName}
                            </Row>
                        </Row>

                        <Row>
                            <Row className="field-headers">
                                Bank Name   
                            </Row>

                            <Row className="field-content">
                                {bankName}
                            </Row>
                            
                        </Row>
                        
                        <Row>
                            <Row className="field-headers">
                                Account Number
                            </Row>

                            <Row className="field-content">
                                {accountNumber}
                            </Row>
                             
                        </Row>

                        <Row>
                            <Row className="field-headers">
                                Bank Code
                            </Row>

                            <Row className="field-content">
                                {bankCode}
                            </Row>
                            
                        </Row>

                        <Row>
                            <Row className="field-headers">
                                Swift Code 
                            </Row>

                            <Row className="field-content">
                                {swiftCode}
                            </Row>
                            
                        </Row>
                    </Col>

                    <Col span={12}>
                        
                        <Row>
                            <Row className="field-headers">
                              Company Name
                            </Row>
                            
                            <Row className="field-content">
                                {companyName}
                            </Row>
                        </Row>

                        <Row>
                            <Row className="field-headers">
                              Address   
                            </Row>

                            <Row className="field-content">
                                {address}
                            </Row>

                            <Row className="field-content">
                                {unit}
                            </Row>
                            
                            
                        </Row>
                        
                        <Row>
                            <Row className="field-headers">
                                Postal Code  
                            </Row>

                            <Row className="field-content">
                                {postalCode}
                            </Row>
                        
                        </Row>

                        <Row>
                            <Row className="field-headers">
                              GST Registered  
                            </Row>

                            <Row className="field-content">
                                {(gstRegistered)? "yes" : "no"}
                            </Row>
                        </Row>
                    </Col>

                </Row>
                    
                    
                </Modal>
            )
        }

        
    }

    constructor(props) {
        super(props);
        this.state = {
            accountingDocument: false,
            companyProfileDocument: false,
            isAccountingInfoVerified: false,
            isCompanyInfoVerified: false,
            supplierId: props.supplierId,
            supplier: false,
            
            
        }
    }

    componentWillMount() {
        
        _getSupplierInformation(this.props.supplierId)
            .then (res => {
                // console.log(res)

                let { verification } = res.data.supplier;

                        verification = verification || {};

                const   accountingDocument = (verification && verification.bankInfo && verification.bankInfo.document) || false,
                        isAccountingInfoVerified = (verification && verification.bankInfo && verification.bankInfo.approve) || false,
                        companyProfileDocument = (verification && verification.companyProfile && verification.companyProfile.document) || false,
                        isCompanyInfoVerified = (verification && verification.companyProfile && verification.companyProfile.approve) || false;

                this.setState({
                    supplier: res.data.supplier,
                    accountingDocument,
                    isAccountingInfoVerified,
                    companyProfileDocument,
                    isCompanyInfoVerified
                })

                // setTimeout(() => {
                //     console.log("this.state =  " , this.state)
                // }, 1000)
            })
        
    }
    handleCancel = () => {
        this.props.handleCancel();
    }

    handleOk = () => {
        this.props.handleOk( this.state.isAccountingInfoVerified, this.state.isCompanyInfoVerified )
    }

    handleAccountingVerified = (e) => {
        this.setState({
            isAccountingInfoVerified: !this.state.isAccountingInfoVerified
        })
        // setTimeout(() => {
        //     console.log("e =" , e , " state.acccounting boolean" ,  this.state.isAccountingInfoVerified)
        // }, 1000)
    }

    handleCompanyVerified = (e) => {
        this.setState ({
            isCompanyInfoVerified: !this.state.isCompanyInfoVerified
        })

        
    }
}

export default VerifyModal;


// WEBPACK FOOTER //
// ./src/components/supplier-profile/profile-header/verify-modal.js